import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Menu/Search",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.75 7.32803C3.75 4.56956 5.98619 2.33337 8.74466 2.33337C11.5031 2.33337 13.7393 4.56956 13.7393 7.32803C13.7393 10.0865 11.5031 12.3227 8.74466 12.3227C5.98619 12.3227 3.75 10.0865 3.75 7.32803ZM8.74466 1.33337C5.4339 1.33337 2.75 4.01727 2.75 7.32803C2.75 10.6388 5.4339 13.3227 8.74466 13.3227C10.1473 13.3227 11.4374 12.841 12.4586 12.0339L14.3675 13.9379C14.563 14.1329 14.8796 14.1325 15.0746 13.937C15.2696 13.7415 15.2692 13.4249 15.0737 13.2299L13.1895 11.3505C14.1526 10.2869 14.7393 8.87597 14.7393 7.32803C14.7393 4.01727 12.0554 1.33337 8.74466 1.33337Z",
			fill: "#869496"
		})
	})
});
export default SvgSearchIcon;
